import WebSocketClient from "@/classes/Core/WebSocketClient";
import { reactive }    from "vue";

export default class WebSockets
{

    constructor( core )
    {

        if( !WebSockets.instance )
        {

            this.core = core
            this.store = core.getStore()
            this.config = core.getConfig()
            this.keyRing = core.getKeyRing()
            this.logger = core.getLogger()
            this.eventManager = core.getEventManager()

            this.sockets = {
                local : false,
                remote: false
            }

            this.state = reactive(
                { local: false, remote: false }
            )

            this.ready = false
            this.setup()
            this.logger.clog( 'WebSockets', 'initializing...' )

            this.eventManager.add( 'after-provisioning-startover', () =>
            {
                this.startOver()
            } )

            WebSockets.instance = this

        }

        return WebSockets.instance

    }

    awaitReadiness()
    {
        return new Promise( resolve =>
        {

            if( this.ready )
            {
                return resolve()
            }
            else
            {
                setTimeout( () =>
                {
                    return resolve( this.awaitReadiness() )
                }, 300 )
            }

        } )
    }

    setup()
    {

        this.keyRing
            .awaitReadiness()
            .then( () =>
            {

                let localUri  = this.keyRing.ring.openSetup.localAddress,
                    remoteUri = this.keyRing.ring.openSetup.remoteAddress

                this.sockets.local = new WebSocketClient( this.core, 'local', localUri, this.keyRing.ring.openSetup.user )
                this.sockets.remote = new WebSocketClient( this.core, 'remote', remoteUri, this.keyRing.ring.openSetup.user )

                this.eventManager.add( 'on-socket-state-change', ( data ) => {
                    this.handleSocketStateChange( data )
                })

                setTimeout( () =>
                {
                    this.ready = true
                }, 1000 )

            } )

    }

    startOver()
    {
        delete this.sockets.local
        delete this.sockets.remote
        this.setup()
    }

    command( command, scope )
    {
        return new Promise( ( resolve, reject ) =>
        {

            if( undefined !== scope )
            {
                this.sockets[ scope ].command( command )
                                     .then( response =>
                                     {
                                         return resolve( response.data.result )
                                     } )
                                     .catch( e =>
                                     {
                                         return reject( e )
                                     } )
            }
            else
            {

                if( true === this.store.getters.localConnected
                    && true === this.store.getters.localAuthorized )
                {
                    this.command( command, 'local' )
                        .then( response =>
                        {
                            return resolve( response )
                        } )
                        .catch( e =>
                        {
                            return reject( e )
                        } )
                }
                else
                {
                    this.command( command, 'remote' )
                        .then( response =>
                        {
                            return resolve( response )
                        } )
                        .catch( e =>
                        {
                            return reject( e )
                        } )
                }

            }
        } )
    }

    request( request, scope )
    {
        
        return new Promise( ( resolve, reject ) =>
        {

            if( !this.ready )
            {
                setTimeout( () =>
                {
                    return resolve( this.request( request, scope ) )
                }, 500 )
            }
            else
            {


                if( undefined !== scope )
                {
                    this.sockets[ scope ].request( request )
                                         .then( response =>
                                         {
                                             if( response.data )
                                             {
                                                 return resolve( response.data.result || response.data )
                                             }
                                             else
                                             {
                                                 return resolve()
                                             }
                                         } )
                                         .catch( e =>
                                         {
                                             return reject( e )
                                         } )
                }
                else
                {

                    if( true === this.store.getters.localConnected
                        && true === this.store.getters.localAuthorized )
                    {
                        this.request( request, 'local' )
                            .then( response =>
                            {
                                return resolve( response )
                            } )
                            .catch( e =>
                            {
                                return reject( e )
                            } )
                    }
                    else
                    {
                        this.request( request, 'remote' )
                            .then( response =>
                            {
                                return resolve( response )
                            } )
                            .catch( e =>
                            {
                                return reject( e )
                            } )
                    }

                }

            }
        } )

    }

    handleSocketStateChange( data )
    {

        let scope = data.scope.toLowerCase()
        this.state[scope] = data.state

        let allTrue = false
        for( let s in this.state )
        {
            if( this.state[s] )
            {
                allTrue = true
            }
        }

        this.eventManager.dispatch( 'on-sockets-ready' )

    }

}